import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Card,
  Container,
  FormHelperText,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import Select from "../../../components/Select/Select";
import { getClinicStocks } from "../../../redux/reducers/clinicSlice";
import {
  createPrescription,
  createPrescriptionByPetId,
  getPetPrescriptions,
  getPetsCompliantSummary,
  updatedDiscontinueByPresDetId,
  updatePrescriptionById,
} from "../../../redux/reducers/petSlice";
import { showSnackBar } from "../../../redux/reducers/snackSlice";
import { AppColors } from "../../../util/AppColors";
import { frequncyCheckList } from "../../../util/arrayList";
import { addIcon, delBtn } from "../../../util/CommonIconStyle";
import { mealTypes, routeList } from "../../../util/dropList";
import { getAddedDate, getRightSaluation } from "../../../util/function";
import { tblGrayBack } from "../../../util/object";

const tblHdrs = [
  "name",
  "qty",
  "dosage",
  "startDate",
  "endDate",
  "frequency",
  "instructions",
  "status",
];
const nameExpan = {
  name: "Name",
  qty: "Qty",
  dosage: "Dosage",
  startDate: "Start Date",
  endDate: "End Date",
  frequency: "Frequency",
  instructions: "Instructions",
  status: "",
};

const initPres = {
  name: null,
  dosage: "1",
  duration: "1",
  frequency: [],
  meal: "",
  customFrequency: false,
  route: routeList?.[0],
  plName: null,
};

const cardSty = {
  borderRadius: 1,
  paddingLeft: 2,
  paddingRight: 2,
  paddingTop: 1,
  paddingBottom: 1,
  borderTopColor: AppColors.appPrimary,
  marginLeft: 1,
  marginRight: 1,
};

const arrIcon = { width: 30, height: 30, color: AppColors.appPrimary };

const ReminderPrescription = ({ addVsble, setAddVsble, presFilter }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { appointment } = location.state || {};
  const [prescriptionList, setPrescriptionList] = useState([]);
  const [presItems, setPresItems] = useState([]);
  const [remark, setRemark] = useState("");
  const [prevModVisible, setPrevModVisible] = useState(false);
  const [isPreUploaded, setPreUploaded] = useState(false);
  const [viewPresValue, setViewPresValue] = useState(null);
  const [selectedPrescription, setSelectedPrescrision] = useState(null);
  const [tblVisible, setTblVisible] = useState(false);
  const [conModVsble, setConModVsble] = useState(false);
  const [selectedItem, setSelecetdItem] = useState(null);
  const [notValErr, setNotValErr] = useState(false);
  const [validationErrors, setValidationErrors] = useState({
    name: {},
    batchNo: {},
    qty: {},
    plName: {},
  });
  const [isEdit, setIsEdit] = useState(false);
  const [admNotValErr, setAdmNotValErr] = useState(false);
  const [presOpen, setPresOpen] = useState(true);
  const [warnModVsble, setWarnModVsble] = useState(false);
  const itemsPerLoad = 5;
  const appointmentId = appointment?.appoinment?.appointmentId;
  const petId = appointment?.appoinment?.petId;
  const defaultUrl = `?page=1&itemSize=${itemsPerLoad}`;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const metHisDet = useSelector(
    (state) => state?.pet?.complaintSummary?.data?.medicalHistory
  );
  const prescriptions = useSelector((state) => state?.pet?.prescriptions);
  const appDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const stocks = useSelector((state) => state?.clinic?.clinicStocks);
  const clinicDet = useSelector((state) => state?.clinic?.details);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const apntmnt = appDet?.appointment;

  useEffect(() => {
    dispatch(getPetPrescriptions({ petId, url: defaultUrl })).then((res) => {
      if (res?.payload) {
        const prevUnsavedList = localStorage.getItem("presUnsavedList");
        if (prevUnsavedList) {
          const unSavedList = JSON.parse(prevUnsavedList);
          const currPetUnSavedList = unSavedList?.find(
            (li) => li?.petId === petId
          );
          if (currPetUnSavedList) {
            setPrescriptionList(currPetUnSavedList?.presList ?? []);
            setTblVisible(true);
          }
        }
      }
    });
    dispatch(getClinicStocks());
    if (appDet?.appointment?.appointmentId) {
      dispatch(getPetsCompliantSummary(appDet?.appointment?.appointmentId));
    }
  }, []);

  useEffect(() => {
    if (addVsble) setTblVisible(true);
  }, [addVsble]);

  useEffect(() => {
    const getAllList = extractPrescriptionDetails(prescriptions?.data);
    const reqList = getAllList
      ?.filter(
        (li) => new Date(li?.endDate) >= new Date(new Date().setHours(0, 0, 0))
      )
      ?.map((li) => ({
        ...li,
        frequency:
          !li?.morning && !li?.afternoon && li?.night
            ? li?.frequencyDuration ?? ""
            : `${li?.morning ? "Morn" : ""}${
                li?.afternoon ? `${li?.morning ? ", " : ""}Noon` : ""
              }${li?.night ? `${li?.afternoon ? ", " : ""}Night` : ""}`,
        instructions:
          li?.meal === "afterMeal"
            ? "After Meal"
            : li?.meal === "beforeMeal"
            ? "Before Meal"
            : "",
        qty: `${li?.quantity} ${
          getBatchList(li?.stockId)?.[0]?.salesUom ?? ""
        }`,
      }));
    setPresItems(reqList);
  }, [prescriptions]);

  function extractPrescriptionDetails(list) {
    const reqList = [];
    list?.forEach((li) => {
      const apntDate = li?.createdDate;
      li?.prescriptionDetails?.forEach((pl) => {
        const endDate = getAddedDate(apntDate, Number(pl?.duration ?? 1));
        reqList.push({ ...pl, startDate: apntDate, endDate });
      });
    });
    return reqList;
  }

  const getListBySelectedType = () => {
    const reqList = stocks?.data?.filter((dta) => {
      return (
        dta?.billable &&
        (dta?.category?.toLowerCase() === "medication" ||
          dta?.category?.toLowerCase() === "diet" ||
          dta?.category?.toLowerCase() === "nutrition and supplements" ||
          dta?.category?.toLowerCase() === "fluid therapy" ||
          dta?.category?.toLowerCase() === "other parasite treatment" ||
          dta?.category?.toLowerCase() === "deworming" ||
          dta?.category?.toLowerCase() === "flea & tick treatment" ||
          dta?.category?.toLowerCase() === "grooming & hygiene care")
      );
    });
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
      productName: li?.productName,
    }));
  };

  const handleAfterUpdate = () => {
    setAddVsble(false);
    setTblVisible(false);
    dispatch(getPetPrescriptions({ petId, url: defaultUrl }));
    dispatch(getPetsCompliantSummary(apntmnt?.appointmentId));
    setPreUploaded(true);
    setSelectedPrescrision(null);
    setIsEdit(false);
    setPrevModVisible(false);
    localStorage.removeItem("presUnsavedList");
  };

  const validateFields = () => {
    const errors = {
      name: {},
      batchNo: {},
      qty: {},
      plName: {},
    };
    let isValid = true;
    // Validate Prescribed prescriptions
    prescriptionList.forEach((pres, index) => {
      if (!pres.plName) {
        errors.plName[index] = "Name is required";
        isValid = false;
      }
      if (!pres?.qty || isNaN(Number(pres?.qty)) || Number(pres?.qty) <= 0) {
        errors.qty[index] = "Quantity is required";
        isValid = false;
      }
    });
    setValidationErrors(errors);
    return isValid;
  };

  const handleAddAnUpdatePrescription = async () => {
    if (!validateFields()) return;
    if (
      appointmentId &&
      (appDet?.procedures?.length === 0 || !appDet?.procedures)
    ) {
      return setWarnModVsble(true);
    }
    if (prescriptionList?.length === 0) {
      setNotValErr(true);
      return setAdmNotValErr(true);
    }
    if (
      prescriptionList?.filter(
        (pl) =>
          pl?.plName === "" || pl?.plName === null || pl?.plName === undefined
      )?.length > 0
    ) {
      setNotValErr(true);
      setAdmNotValErr(true);
      return;
    }
    if (apntmnt?.appointmentId && apntmnt?.appointmentStatus !== "completed") {
      const unSavedWorkBook = localStorage.getItem("unSavedWorkbook");
      if (unSavedWorkBook) {
        const parsedValue = JSON.parse(unSavedWorkBook);
        const reqPresList = [
          ...parsedValue?.presList,
          ...prescriptionList,
        ]?.map((pl, i) => ({ ...pl, i }));
        const reqObj = {
          procedures: parsedValue?.procedures,
          presList: reqPresList,
          consumList: parsedValue?.consumList,
          adminList: parsedValue?.adminList,
        };
        localStorage.setItem("unSavedWorkbook", JSON.stringify(reqObj));
        window.dispatchEvent(
          new CustomEvent("localStorageUpdate", {
            detail: { key: "unSavedWorkbook" },
          })
        );
        dispatch(
          showSnackBar({
            message: "Record moved to workbook successfully!",
            type: "success",
          })
        );
        setAddVsble(false);
        setTblVisible(false);
        setPreUploaded(true);
        setSelectedPrescrision(null);
        setIsEdit(false);
        setPrevModVisible(false);
        localStorage.removeItem("presUnsavedList");
        return;
      }
    }
    let prescription = [];
    if (
      prescriptionList?.length > 0 &&
      prescriptionList?.filter(
        (pl) =>
          pl?.plName === "" || pl?.plName === null || pl?.plName === undefined
      )?.length === 0
    ) {
      const reqPres = prescriptionList?.map((pre) => {
        const selStock = stocks?.data?.find(
          (stc) => stc?.stockId === pre?.stockId
        );
        const reqObj = {
          administered: false,
          type: pre?.type ?? null,
          stockId: pre?.stockId,
          batchId: selStock?.stockBatch?.[0]?.batchId ?? null,
          name: pre?.plName,
          dosage: pre?.dosage,
          duration: pre?.duration,
          meal: pre?.meal,
          quantity: typeof pre?.qty === "undefined" ? 1 : Number(pre?.qty),
          subUnit: "Unit",
          morning:
            (pre?.frequency?.includes("morning") &&
              !pre?.frequency?.includes("Custom")) ??
            false,
          afternoon:
            (pre?.frequency?.includes("afternoon") &&
              !pre?.frequency?.includes("Custom")) ??
            false,
          night:
            (pre?.frequency?.includes("night") &&
              !pre?.frequency?.includes("Custom")) ??
            false,
          adminChargeAmount: 0,
          adminCharge: "N",
          percentage: false,
          delete: false,
          discontinued: "N",
        };
        const btchDet = selStock?.stockBatch?.[0];
        const taxPercent =
          clinicDet?.pharmacyTaxId?.length > 0
            ? (btchDet?.cgst ? Number(btchDet?.cgst) : 0) +
              (btchDet?.sgst ? Number(btchDet?.sgst) : 0)
            : 0;
        const reqPercent = 100 + Number(taxPercent);
        const unitPrice =
          (btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0) /
          (reqPercent / 100);
        const taxValue =
          Number(
            (btchDet?.unitSellingPrice
              ? Number(btchDet?.unitSellingPrice)
              : 0) - Number(unitPrice)
          ) ?? 0;
        reqObj.adminCharge = "N";
        reqObj.adminChargeAmount = 0;
        reqObj.price = unitPrice ?? 0;
        reqObj.mrpPrice = btchDet?.unitSellingPrice
          ? Number(btchDet?.unitSellingPrice)
          : 0;
        reqObj.mrpDiscount =
          // (Number(
          //   btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0
          // ) /
          //   100) *
          // Number(taxPercent);
          reqObj.tax =
            Number(taxValue) *
            Number(typeof pre?.qty === "undefined" ? 1 : pre?.qty);
        reqObj.total =
          (btchDet?.unitSellingPrice ? Number(btchDet?.unitSellingPrice) : 0) *
            Number(typeof pre?.qty === "undefined" ? 1 : pre?.qty) ?? 0;
        if (typeof pre?.frequency === "string") {
          reqObj.frequencyDuration = pre?.frequency;
        }
        if (pre?.productId) reqObj.productId = pre?.productId;
        if (pre?.serviceId) reqObj.serviceId = pre?.serviceId;
        if (selectedPrescription && pre?.id) {
          reqObj.detailId = pre?.id;
          reqObj.delete = pre?.delete;
        }
        return reqObj;
      });
      prescription = [...prescription, ...reqPres];
    }
    const data = {
      status:
        //  selectedPrescription?.status ??
        "Pending",
      remark,
      prescription,
      issue: metHisDet?.[0]?.problemType ?? "",
    };
    if (appDet?.prescription?.[0]?.prescriptionId) {
      dispatch(
        updatePrescriptionById({
          prescriptionId: appDet?.prescription?.[0]?.prescriptionId,
          data,
        })
      ).then((res) => {
        if (res?.payload?.status === 200) {
          handleAfterUpdate();
        }
      });
    } else {
      dispatch(
        appointmentId
          ? createPrescription({ appointmentId, data })
          : createPrescriptionByPetId({ petId, data })
      ).then((res) => {
        if (res?.payload) {
          // const prevUnsavedList = localStorage.getItem("presUnsavedList");
          // if (prevUnsavedList) {
          //   const unSavedList = JSON.parse(prevUnsavedList);
          //   const currPetUnSavedList = unSavedList?.find(
          //     (li) => li?.petId === petId
          //   );
          //   if (currPetUnSavedList) {
          //     const presListWOCurPet = unSavedList?.filter(
          //       (li) => li?.petId !== petId
          //     );
          //     localStorage.setItem(
          //       "presUnsavedList",
          //       JSON.stringify(presListWOCurPet)
          //     );
          //   }
          // }
          handleAfterUpdate();
        }
      });
    }
  };

  const handleAddNewPres = () => {
    const reqList = [
      ...prescriptionList,
      { ...initPres, i: prescriptionList?.length },
    ];
    if (!selectedPrescription) {
      const prevUnsavedList = localStorage.getItem("presUnsavedList");
      if (!prevUnsavedList) {
        localStorage.setItem(
          "presUnsavedList",
          JSON.stringify([{ petId, presList: reqList }])
        );
      } else {
        const reqLists = JSON.parse(prevUnsavedList);
        const prevPet = reqLists?.find((li) => li?.petId === petId);
        let reqPetPresList = [];
        if (prevPet) {
          reqPetPresList = reqLists?.map((li) => {
            if (li?.petId === petId) {
              return { ...li, presList: reqList };
            }
            return li;
          });
        } else {
          reqPetPresList = [...reqList, { petId, presList: reqList }];
        }
        localStorage.setItem("presUnsavedList", JSON.stringify(reqPetPresList));
      }
    }
    setPrescriptionList(reqList);
  };

  const handleChangePresValue = (name, value, ind, addObj) => {
    const reqList = prescriptionList?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "frequency") {
          if (value?.includes("Custom")) {
            reqObj.frequency = "";
            reqObj.customFrequency = true;
          }
        }
        if (name === "plName" && addObj) {
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          if (addObj?.stockId) {
            const reqBatch = stocks?.data?.find(
              (stc) => stc?.stockId === addObj?.stockId
            )?.stockBatch?.[0];
            reqObj.dosage = reqBatch?.dosage;
          }
        }
        if (name === "type") reqObj.name = null;
        if (addObj?.productId) {
          reqObj.productId = addObj?.productId;
        }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;

        return reqObj;
      }
      return pl;
    });
    if (!selectedPrescription) {
      const prevUnsavedList = localStorage.getItem("presUnsavedList");
      if (!prevUnsavedList) {
        localStorage.setItem(
          "presUnsavedList",
          JSON.stringify([{ petId, presList: reqList }])
        );
      } else {
        const reqLists = JSON.parse(prevUnsavedList);
        const prevPet = reqLists?.find((li) => li?.petId === petId);
        let reqPetPresList = [];
        if (prevPet) {
          reqPetPresList = reqLists?.map((li) => {
            if (li?.petId === petId) {
              return { ...li, presList: reqList };
            }
            return li;
          });
        } else {
          reqPetPresList = [...reqList, { petId, presList: reqList }];
        }
        localStorage.setItem("presUnsavedList", JSON.stringify(reqPetPresList));
      }
    }
    setPrescriptionList(reqList);
    if (
      reqList?.filter(
        (pl) =>
          pl?.plName === "" || pl?.plName === null || pl?.plName === undefined
      )?.length > 0
    ) {
      return setNotValErr(true);
    }
    setNotValErr(false);
  };

  const handlePreModClose = () => {
    setViewPresValue(null);
    setPrevModVisible(false);
  };

  const deletePresByIndex = (ind) => {
    let reqList = [];
    if (selectedPrescription) {
      reqList = prescriptionList?.map((rl, i) => {
        if (i === ind) {
          return { ...rl, delete: true };
        }
        return rl;
      });
    } else {
      reqList = prescriptionList
        .filter((pre, i) => {
          return i !== ind;
        })
        ?.map((rl, i) => ({ ...rl, i }));
    }
    if (!selectedPrescription) {
      const prevUnsavedList = localStorage.getItem("presUnsavedList");
      if (!prevUnsavedList) {
        localStorage.setItem(
          "presUnsavedList",
          JSON.stringify([{ petId, presList: reqList }])
        );
      } else {
        const reqLists = JSON.parse(prevUnsavedList);
        const prevPet = reqLists?.find((li) => li?.petId === petId);
        let reqPetPresList = [];
        if (prevPet) {
          reqPetPresList = reqLists?.map((li) => {
            if (li?.petId === petId) {
              return { ...li, presList: reqList };
            }
            return li;
          });
        } else {
          reqPetPresList = [...reqList, { petId, presList: reqList }];
        }
        localStorage.setItem("presUnsavedList", JSON.stringify(reqPetPresList));
      }
    }
    setPrescriptionList(reqList);
  };

  const getListByType = (adminstered = false) => {
    return viewPresValue
      ? viewPresValue?.prescriptionDetails?.filter((pd) => {
          const filterValue = adminstered ? "admininstered" : "prescribed";
          const currAdmin =
            pd?.administered?.toLowerCase() === "admininstered" ||
            pd?.administered?.toLowerCase() === "administered"
              ? "admininstered"
              : "prescribed";
          return currAdmin === filterValue;
        })
      : prescriptionList;
  };

  const renderData = (li, currPrd, administerd = false) => {
    return (
      <div className="gray-back-con" key={Date.now() + li?.id}>
        <div className="flex-row flex-row-wrap">
          <div className="w85Per">
            <div className="flex-row flex-row-wrap">
              <div className="font-bold fs12 black">
                {li?.name ?? li?.plName}
              </div>
              <div className="flex-row flex-center ml10">
                <div className="gray-dot" />
                <div className="font-medium fs12 black4 ml5">Quantity:</div>
                <div className="txt-regular fs12 black4 ml3">
                  {li?.quantity ?? li?.qty ?? "1"}{" "}
                  {li?.subUnit === "Unit" || li?.unitType === "Unit"
                    ? currPrd?.measurementUnit
                    : currPrd?.subMeasurementUnit}
                </div>
              </div>
              <div className="flex-row flex-center ml10">
                <div className="gray-dot" />
                <div className="font-medium fs12 black4 ml5">Dosage:</div>
                <div className="txt-regular fs12 black4 ml3">{li?.dosage}</div>
              </div>
              <div className="flex-row flex-center ml10">
                <div className="gray-dot" />
                <div className="font-medium fs12 black4 ml5">Duration:</div>
                <div className="txt-regular fs12 black4 ml3">
                  {li?.duration ?? "1"} days
                </div>
              </div>
              {li?.meal?.length > 0 ? (
                <div className="flex-row flex-center ml10">
                  <div className="gray-dot" />
                  <div className="txt-regular fs12 black4 ml5">
                    {li?.meal === "afterMeal"
                      ? "After Meal"
                      : li?.meal === "beforeMeal"
                      ? "Before Meal"
                      : ""}
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          {administerd ? null : (
              viewPresValue
                ? li?.morning ||
                  li?.afternoon ||
                  li?.night ||
                  li?.frequencyDuration?.length > 0
                : (typeof li?.frequency === "string" &&
                    li?.frequency?.length > 0) ||
                  li?.frequency?.includes("morning") ||
                  li?.frequency?.includes("afternoon") ||
                  li?.frequency?.includes("night")
            ) ? (
            <div className="flex-center">
              <div className="blue-back-con fs12 font-medium">
                {viewPresValue
                  ? !li?.morning && !li?.afternoon && !li?.night
                    ? li?.frequencyDuration
                    : `${li?.morning ? "1" : "0"}-${
                        li?.afternoon ? "1" : "0"
                      }-${li?.night ? "1" : "0"}`
                  : typeof li?.frequency === "string"
                  ? li?.frequency
                  : `${li?.frequency?.includes("morning") ? "1" : "0"}-${
                      li?.frequency?.includes("afternoon") ? "1" : "0"
                    }-${li?.frequency?.includes("night") ? "1" : "0"}`}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  const getListDataToShow = () => {
    return (
      <div>
        {getListByType(false)?.length > 0 ? (
          <div>
            <div className="font-bold fs14 blue-color mv10">Prescribed</div>
            {getListByType(false)?.map((li) => {
              const currPrd = stocks?.data?.find(
                (dta) => dta?.stockId === li?.stockId
              );
              return renderData(li, currPrd, false);
            })}
          </div>
        ) : null}
      </div>
    );
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    if (!reqStock) return [];
    const filteredBatches = reqStock?.stockBatch
      // ?.filter((btch) => btch?.billlable === "Y")
      ?.map((btch) => ({
        name: btch?.batchNo,
        value: btch?.batchNo,
        batchId: btch?.batchId,
        salesUom: btch?.salesUom,
        packageUom: btch?.packageUom,
      }));
    return filteredBatches;
  };

  const handlePresOpen = () => {
    setPresOpen(!presOpen);
  };

  const onCloseMod = () => {
    setAddVsble(false);
    setTblVisible(false);
  };

  const onCloseConMod = () => {
    setConModVsble(false);
    setSelecetdItem(null);
  };

  const onDiscontinue = (itm) => {
    setSelecetdItem(itm);
    setConModVsble(true);
  };

  const onConfirmMod = () => {
    if (!selectedItem?.id) return;
    dispatch(updatedDiscontinueByPresDetId(selectedItem?.id)).then((res) => {
      if (res?.payload) {
        onCloseConMod();
        handleAfterUpdate();
      }
    });
  };

  const getFilteredList = () => {
    const reqList = presItems?.filter((li) => {
      const statMatch =
        presFilter === "All"
          ? true
          : presFilter === "Active"
          ? li?.discontinued === "N"
          : li?.discontinued === "Y";
      return statMatch;
    });
    return reqList;
  };

  return (
    <>
      <Container maxWidth="xl">
        <TableContainer sx={{ maxHeight: 400 }} className="mv20">
          <Table
            sx={{ minWidth: 200 }}
            aria-labelledby="tableTitle"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                {tblHdrs?.map((hdr, i) => (
                  <TableCell
                    style={tblGrayBack}
                    className="table-header-text"
                    key={hdr + i}
                  >
                    {nameExpan?.[hdr]}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {getFilteredList()?.length === 0 && (
              <TableRow>
                <TableCell colSpan={12} className="text-align-center h100">
                  <div className="no-rec">No records available</div>
                </TableCell>
              </TableRow>
            )}
            <TableBody>
              {getFilteredList()?.map((li, ind) => {
                return (
                  <TableRow>
                    {tblHdrs?.map((hdr, i) => {
                      return (
                        <TableCell key={`${ind} + ${i} + tr`} component="th">
                          <div
                            style={{ width: hdr === "name" ? 150 : "auto" }}
                            className="fs14 txt-regular black"
                          >
                            {hdr === "name" ? (
                              <Custom3dotString
                                str={li?.[hdr]}
                                className="fs14 txt-semi-bold black"
                                length={25}
                              />
                            ) : hdr === "frequency" ? (
                              <Custom3dotString
                                str={li?.[hdr]}
                                className="fs14 txt-regular black"
                                length={15}
                              />
                            ) : hdr === "startDate" || hdr === "endDate" ? (
                              moment(li?.[hdr]).format("DD MMM YYYY")
                            ) : hdr === "status" ? (
                              li?.discontinued === "Y" ? (
                                <CustomButton
                                  smallBtn
                                  text="Discontinued"
                                  disabled
                                  grayBtn
                                />
                              ) : (
                                <CustomButton
                                  smallBtn
                                  text="Discontinue"
                                  yellowBtn
                                  onClick={() => onDiscontinue(li)}
                                />
                              )
                            ) : (
                              li?.[hdr]
                            )}
                          </div>
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      <CustomModal
        open={tblVisible}
        onClose={onCloseMod}
        header=""
        rightModal
        modalWidth={90}
      >
        <div className="scroll-80vh">
          <div className="w100Per">
            <Card sx={cardSty} className="mt20">
              <div className="flex-row-ali-cen cursor" onClick={handlePresOpen}>
                {presOpen ? (
                  <ArrowDropDownIcon sx={arrIcon} />
                ) : (
                  <ArrowRightIcon sx={arrIcon} />
                )}
                <Typography className="font-bold fs14 gray20">
                  Prescribed
                </Typography>
              </div>
              {presOpen ? (
                <div className="flex-column">
                  <div className="flex-row-ali-cen mh10">
                    <div className="w25Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Name <span className="red-color">*</span>
                      </Typography>
                    </div>
                    <div className="w18Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Qty <span className="red-color">*</span>
                      </Typography>
                    </div>
                    <div className="w15Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Dosage
                      </Typography>
                    </div>
                    <div className="w12Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Duration
                      </Typography>
                    </div>
                    <div className="w15Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Frequency
                      </Typography>
                    </div>
                    <div className="w10Per">
                      <Typography className="txt-semi-bold fs12 blue-color">
                        Instructions
                      </Typography>
                    </div>
                    <div className="w5Per" />
                  </div>
                  <div className="blue-hor-split mt5" />
                  {prescriptionList
                    ?.filter((li) => !li?.delete)
                    ?.map((pr, ind) => {
                      return (
                        <div
                          className="flex-row mt10 plan-bor"
                          key={pr?.i + "pres"}
                        >
                          <div className="w25Per pr10">
                            <Select
                              list={getListBySelectedType()}
                              value={pr?.plName}
                              addNewSelect
                              mandatoryField
                              handleChange={(e) => {
                                handleChangePresValue(
                                  "plName",
                                  e?.value ?? e,
                                  pr?.i,
                                  {
                                    stockId: e?.stockId ?? null,
                                    productId: e?.productId ?? null,
                                    serviceId: e?.serviceId ?? null,
                                    type: e?.type,
                                  }
                                );
                                setValidationErrors((prev) => ({
                                  ...prev,
                                  plName: {
                                    ...prev.plName,
                                    [pr?.i]: undefined,
                                  },
                                }));
                              }}
                              disabled={isPreUploaded}
                              error={!!validationErrors.plName[pr?.i]}
                              helperText={validationErrors.plName[pr?.i]}
                              plusBtn
                            />
                          </div>
                          <div className="w18Per pr10">
                            <CustomTextField
                              value={pr?.qty}
                              handleChange={(e) => {
                                handleChangePresValue(
                                  "qty",
                                  e?.target?.value,
                                  pr?.i
                                );
                                setValidationErrors((prev) => ({
                                  ...prev,
                                  qty: { ...prev.qty, [pr?.i]: undefined },
                                }));
                              }}
                              fullWidth
                              type="number"
                              endIcon
                              inputIcon={
                                getBatchList(pr?.stockId)?.[0]?.salesUom ?? ""
                              }
                              error={!!validationErrors.qty[pr?.i]}
                              helperText={validationErrors.qty[pr?.i]}
                              disabled={isPreUploaded}
                            />
                          </div>
                          <div className="w15Per pr10">
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                handleChangePresValue(
                                  "dosage",
                                  e?.target?.value,
                                  pr?.i
                                )
                              }
                              value={pr?.dosage}
                              disabled={isPreUploaded}
                              suffix={
                                getBatchList(pr?.stockId)?.[0]?.packageUom ? (
                                  <Custom3dotString
                                    str={`/${
                                      getBatchList(pr?.stockId)?.[0]?.packageUom
                                    }`}
                                    className="fs12 font-medium"
                                  />
                                ) : (
                                  ""
                                )
                              }
                            />
                          </div>
                          <div className="w12Per pr10">
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                handleChangePresValue(
                                  "duration",
                                  e?.target?.value,
                                  pr?.i
                                )
                              }
                              value={pr?.duration}
                              endIcon
                              inputIcon="days"
                              disabled={isPreUploaded}
                            />
                          </div>
                          <div className="w15Per pr10">
                            {pr?.customFrequency ? (
                              <CustomTextField
                                fullWidth
                                handleChange={(e) =>
                                  handleChangePresValue(
                                    "frequency",
                                    e?.target?.value,
                                    pr?.i
                                  )
                                }
                                value={pr?.frequency}
                                disabled={isPreUploaded}
                              />
                            ) : (
                              <Select
                                list={frequncyCheckList}
                                value={pr?.frequency ?? []}
                                handleChange={(e) => {
                                  handleChangePresValue(
                                    "frequency",
                                    e?.target?.value,
                                    pr?.i
                                  );
                                }}
                                multiSelectTagCheck
                                disabled={isPreUploaded}
                              />
                            )}
                          </div>
                          <div className="w10Per pr10">
                            <Select
                              list={mealTypes}
                              value={pr?.meal}
                              select
                              handleChange={(e) => {
                                handleChangePresValue(
                                  "meal",
                                  e?.target?.value,
                                  pr?.i
                                );
                              }}
                              disabled={isPreUploaded}
                            />
                          </div>
                          <div className="w5Per">
                            {isEdit ||
                            (selectedPrescription
                              ? selectedPrescription?.appoinment
                                  ?.appointmentStatus !== "completed"
                              : true) ? (
                              <div
                                className="cursor mt3"
                                onClick={() => deletePresByIndex(pr?.i)}
                              >
                                <div className="flex-center">
                                  <DeleteOutlineIcon sx={delBtn} />
                                </div>
                                <Typography className="red3 fs8 txt-semi-bold text-align-center">
                                  Delete
                                </Typography>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      );
                    })}
                  <div
                    className="flex-row-ali-cen mt20 cursor"
                    onClick={handleAddNewPres}
                  >
                    <div className="flex-center plus-icon">
                      <AddIcon sx={addIcon} />
                    </div>
                    <Typography className="blue-color fs16 ml5 font-bold">
                      Add
                    </Typography>
                  </div>
                </div>
              ) : null}
            </Card>
            {notValErr && admNotValErr ? (
              <div className="flex-center mt10">
                <FormHelperText error>
                  Please add at least 1 record
                </FormHelperText>
              </div>
            ) : null}
            <div className="mb20 mt15 mh10">
              <CustomTextField
                fullWidth
                multiline
                placeholder="Advice"
                rows={3}
                handleChange={(e) => setRemark(e?.target?.value)}
                value={remark}
                disabled={isPreUploaded}
              />
            </div>
            <div className="flex-end">
              <div className="w15Per">
                <CustomButton
                  text="Preview"
                  smallBtn
                  onClick={() => {
                    if (!validateFields()) {
                      return;
                    }
                    setPrevModVisible(true);
                  }}
                />
              </div>
              {!isPreUploaded && tblVisible && selectedPrescription ? (
                <div className="w15Per ml15">
                  <CustomButton
                    text="Update"
                    smallBtn
                    onClick={handleAddAnUpdatePrescription}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={prevModVisible}
        onClose={handlePreModClose}
        header=""
        modal
        modalWidth={50}
      >
        <div className="scroll-80vh">
          <div className="p5">
            <div className="blue-box-examD">
              <div className="flex-row">
                <div className="w30Per">
                  <div className="flex-column">
                    <div className="flex-row mt10">
                      <div className="font-bold fs14 blue-color">Pet Name:</div>
                      <div className="font-bold fs14 black capitalize ml5">
                        {apntmnt?.petName}
                      </div>
                    </div>
                    <div className="flex-row mv5">
                      <div className="font-bold fs14 blue-color">Breed:</div>
                      <div className="txt-regular fs14 black capitalize ml5">
                        {apntmnt?.breed}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w45Per">
                  <div className="flex-column">
                    <div className="flex-row mt10">
                      <div className="font-bold fs14 blue-color">Vet Name:</div>
                      <div className="font-bold fs14 black ml5 capitalize">
                        {`${getRightSaluation(
                          clinicVets,
                          viewPresValue?.doctorId ?? apntmnt?.doctorId
                        )}${
                          viewPresValue?.doctorName ?? apntmnt?.doctorName ?? ""
                        }`}
                      </div>
                      {viewPresValue?.registrationNo?.length > 0 ||
                      apntmnt?.registrationNo?.length > 0 ? (
                        <div className="flex-row-ali-cen">
                          <div className="font-regular fs14 black ml5">(</div>
                          <div className="font-bold fs14 blue-color ml2">
                            RegNo:
                          </div>
                          <div className="font-regular fs14 black ml5 capitalize">
                            {viewPresValue?.registrationNo ??
                              apntmnt?.registrationNo}{" "}
                            )
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="flex-row mv5">
                      <div className="font-bold fs14 blue-color">Date:</div>
                      <div className="txt-regular fs14 black ml5">
                        {viewPresValue
                          ? moment(viewPresValue?.createdDate).format(
                              "DD MMM YYYY"
                            )
                          : moment().format("DD MMM YYYY")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w25Per">
                  <div className="flex-end">
                    <img
                      alt=""
                      src={
                        clinicDet?.image ??
                        require("../../../assets/images/png/applologo.png")
                      }
                      className="img-h50"
                    />
                  </div>
                </div>
              </div>
              <div className="box-hor-split mv10" />
              {getListDataToShow()}
              <div className="font-bold fs14 blue-color mv10">Advice</div>
              <CustomTextField
                fullWidth
                multiline
                placeholder="Advice"
                rows={3}
                value={viewPresValue ? viewPresValue?.remark : remark}
                disabled
              />
              <div className="flex-row mv20">
                <img
                  src={require("../../../assets/images/jpg/WoofQrCode.jpeg")}
                  alt=""
                  className="img-h50"
                />
                <div className="blu-back wh50 flex-center">
                  <img
                    src={require("../../../assets/images/png/VetInstantLogo.png")}
                    alt=""
                    className="img-h40"
                  />
                </div>
                <div className="flex-center">
                  <div className="font-bold fs14 ml20">
                    Scan to download our app
                  </div>
                </div>
              </div>
            </div>
            {!isPreUploaded && tblVisible && !selectedPrescription ? (
              <div className="flex-center mv20">
                <div className="w15Per">
                  <CustomButton
                    text="Submit"
                    smallBtn
                    onClick={handleAddAnUpdatePrescription}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={conModVsble}
        onClose={onCloseConMod}
        header="Are you sure you want to discontinue this medication?"
        modal
        modalWidth={40}
        headerBlack
      >
        <div className="flex-row-ali-cen">
          <img
            src={require("../../../assets/images/png/med.png")}
            alt=""
            className="img-wh25"
          />
          <Typography className="font-medium fs12 black8 ml10">
            {`${moment(new Date(selectedItem?.startDate)).format(
              "DD MMM YYYY"
            )} - ${moment(new Date(selectedItem?.endDate)).format(
              "DD MMM YYYY"
            )}`}{" "}
            | {selectedItem?.name} {selectedItem?.meal?.length > 0 ? "| " : ""}
            {selectedItem?.meal === "afterMeal"
              ? "After Meal"
              : selectedItem?.meal === "beforeMeal"
              ? "Before Meal"
              : ""}
          </Typography>
        </div>
        <div className="clinic-mod-btn-pos mb10 mt15">
          <div className="mr10">
            <CustomButton text="No" grayBtn smallBtn onClick={onCloseConMod} />
          </div>
          <div className="ml10">
            <CustomButton text="Yes" smallBtn onClick={onConfirmMod} />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={warnModVsble}
        onClose={() => setWarnModVsble(false)}
        header=""
        modal
        modalWidth={30}
        headerShown={false}
      >
        <div className="flex-row">
          <Typography className="txt-semi-bold fs16 text-align-center mv20 orange4">
            Please add atleast one procedure before making an administration
          </Typography>
          <div className="flex1-end mtMin75">
            <IconButton
              aria-label="close"
              onClick={() => setWarnModVsble(false)}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default ReminderPrescription;
